export const LogoHeader = (props) => 
    <div className="bg-gray-500 text-white w-full p-6 flex items-center">
        <h1 className="text-lg font-semibold">{props.headline}</h1>
    </div>